import React from 'react'

export default ({ name, type, placeholder, onChange, onEnter, ...props }) => (
  <div>
    <input 
      type={type || 'text'} 
      name={name} 
      id={name} 
      placeholder={placeholder || name}
      onChange={e => {
        if(onChange) onChange(e.target.value)
      }}
      onKeyDown={(e) => e.keyCode === 13 && onEnter ? onEnter() : null}
      {...props}
    />
  </div>
)


// WEBPACK FOOTER //
// ./src/views/shared/input.js